import {
	AUTH_PROFILE_GET,
	AUTH_PROFILE_GET_ERROR,
	AUTH_GOOGLE_PROFILE_GET_ERROR,
	AUTH_GOOGLE_PROFILE_GET,
	AUTH_PROFILE_UPDATE,
	AUTH_PROFILE_UPDATE_ERROR,
	AUTH_LOG_IN_ERRORS,
	AUTH_LOADING_STATUS,
	AUTH_GET_CATEGORIES_LOG_IN,
	AUTH_GET_CATEGORIES_REGISTER,
	AUTH_CLEAR_CATEGORIES,
	AUTH_MAP_REGISTER,
	AUTH_GET_CATEGORIES_LOADING
} from './types'

const initialState = {
	data: undefined,
	user_id: null,
	isAuthenticated: undefined,
	firebaseAuthToken: undefined,
	firebaseUser: {},
	errors: [],
	loading: false,
	UserLogInCategories: [],
	userRegistrationCategories: [],
	isLoadingCategories: true,
	mapRegisterToken: null,
}

export const state = { ...initialState }

export default {
	[AUTH_GET_CATEGORIES_LOADING]:(state, payload) => {
		state.isLoadingCategories = payload
	},
	[AUTH_MAP_REGISTER]: (state, payload) => {
		state.mapRegisterToken = payload
	},
	[AUTH_GET_CATEGORIES_REGISTER]: (state, payload) => {
		state.userRegistrationCategories = payload
	},
	[AUTH_GET_CATEGORIES_LOG_IN]: (state, payload) => {
		state.UserLogInCategories = payload
	},
	[AUTH_CLEAR_CATEGORIES]: (state) => {
		state.UserLogInCategories = []
		state.userRegistrationCategories = []
	},
	[AUTH_LOG_IN_ERRORS]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[AUTH_PROFILE_GET]: (state, payload) => {
		state.data = payload
		state.isAuthenticated = true
	},

	[AUTH_PROFILE_UPDATE]: (state, payload) => {
		state.data = payload.data
	},

	[AUTH_PROFILE_UPDATE_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
		state.data = undefined
	},

	[AUTH_PROFILE_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
		state.data = undefined
		state.isAuthenticated = false
	},

	[AUTH_GOOGLE_PROFILE_GET]: (state, payload) => {
		state.firebaseAuthToken = payload.credential.accessToken
		state.firebaseUser = payload.user
	},

	[AUTH_GOOGLE_PROFILE_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
		state.firebaseAuthToken = null
		state.firebaseUser = {}
		state.isAuthenticated = false
	},
	[AUTH_LOADING_STATUS]: (state, payload) => {
		state.loading = payload
	},
}
